module.exports = __webpack_public_path__ + "static/media/assessmentTable.c3676c6a.svg";